import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import "./FeedbackForm.css";

const FeedbackForm = ({ examId }) => {
  const navigate = useNavigate();
  const userId = localStorage.getItem("userId");

  const [backendUrl, setBackendUrl] = useState("");

  // ---- Load BACKEND_URL from public/config.js ----
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "/config.js";
    script.onload = () => {
      if (window.env?.BACKEND_URL) {
        console.log("BACKEND_URL loaded:", window.env.BACKEND_URL);
        setBackendUrl(window.env.BACKEND_URL);
      } else {
        console.error("BACKEND_URL not found in config.js");
      }
    };
    script.onerror = () => console.error("Failed to load config.js");
    document.body.appendChild(script);
  }, []);

  // ---- Feedback form fields ----
  const [form, setForm] = useState({
    q1: "",
    q2: "",
    q3: "",
    q4: "",
    q5: "",
    q6: "",
    q7: "",
    q8: "",
    q9: "",
    additional: "",
  });

  const handleChange = (key, value) => {
    setForm({ ...form, [key]: value });
  };

  // ---- Submit feedback ----
  const handleSubmit = async () => {
    if (!backendUrl) {
      alert("Server not ready. Please wait 1–2 sec and try again.");
      return;
    }

    try {
      await axios.post(`${backendUrl}/student-exam/feedback`, {
        userId,
        examId,
        ...form,
      });

      alert("Thank you! Your feedback has been submitted.");
      navigate("/dashboard/student");
    } catch (error) {
      console.error(error);
      alert("Something went wrong while submitting feedback.");
    }
  };

  return (
    <div className="feedback-wrapper">
      <div className="feedback-container">

        <h2>Training Feedback</h2>
        <p>Your feedback helps us improve your learning experience.</p>

        {[
          { key: "q1", label: "How relevant was the training content?" },
          { key: "q2", label: "Were the learning objectives clear?" },
          { key: "q3", label: "Quality of learning materials" },
          { key: "q4", label: "LMS ease of navigation" },
          { key: "q5", label: "Confidence in applying knowledge" },
          { key: "q6", label: "Trainer support responsiveness" },
          { key: "q7", label: "Course pace" },
          { key: "q8", label: "Need additional follow-up resources?" },
          { key: "q9", label: "Overall satisfaction" },
        ].map((q) => (
          <div className="feedback-question" key={q.key}>
            <label>{q.label}</label>
            <select
              value={form[q.key]}
              onChange={(e) => handleChange(q.key, e.target.value)}
            >
              <option value="">Select...</option>
              {getOptions(q.key).map((opt, i) => (
                <option key={i} value={opt}>{opt}</option>
              ))}
            </select>
          </div>
        ))}

        <div className="feedback-question">
          <label>Additional comments (optional)</label>
          <textarea
            value={form.additional}
            onChange={(e) => handleChange("additional", e.target.value)}
            placeholder="Write your comments..."
          ></textarea>
        </div>

        <button className="feedback-submit" onClick={handleSubmit}>
          Submit Feedback
        </button>
      </div>
    </div>
  );
};

export default FeedbackForm;


// ---- Options for dropdowns ----
function getOptions(q) {
  switch (q) {
    case "q1":
      return ["Highly relevant", "Moderately relevant", "Slightly relevant", "Not relevant"];
    case "q2":
      return ["Very clear", "Somewhat clear", "Not very clear", "Completely unclear"];
    case "q3":
      return ["Excellent", "Good", "Fair", "Poor"];
    case "q4":
      return ["Very easy", "Easy with minor issues", "Difficult", "Very difficult"];
    case "q5":
      return ["Very confident", "Confident", "Slightly confident", "Not confident"];
    case "q6":
      return ["Always responsive", "Usually responsive", "Rarely responsive", "Not responsive"];
    case "q7":
      return ["Too fast", "Appropriate", "Too slow", "Mixed"];
    case "q8":
      return ["Yes, very much", "Yes, somewhat", "Not really", "Not at all"];
    case "q9":
      return ["Very satisfied", "Satisfied", "Neutral", "Dissatisfied"];
    default:
      return [];
  }
}
